import type { WiwState } from '@/store';

export const getFlags = (state: WiwState) => {
  return state.workchat.flags;
};
